module.exports = __webpack_public_path__ + "static/roadmap-6fe9be3c73eea66bcad8e829ce130691.png";